import { call, put, select } from 'redux-saga/effects';
import { User, UserId } from 'features/users/types';
import { selectLocalUserId, selectUserById } from 'features/users/usersSlice';
import { logger } from 'utils/logger';
import { notification } from 'features/notifications/toast/notification';
import i18n from 'i18n';
import {
  signalingEditWhiteboardAllowed,
  whiteboardPermissionGranted,
} from 'features/permissions/actions';

export function* onEditWhiteboardAllowedSaga({
  payload,
}: ReturnType<typeof signalingEditWhiteboardAllowed>) {
  const { data, initiator } = payload;

  const localUserId: UserId = yield select(selectLocalUserId);

  for (const id of data.users) {
    if (localUserId === id) {
      logger
        .remote({ tier: 1 })
        .info(`The user was allowed to edit whiteboard by user id=${initiator.id}`);

      const initiatorUser: User = yield select(selectUserById, initiator.id);

      yield call(
        notification,
        i18n.t('notifications:whiteboard_edit_allowed', { username: initiatorUser.name })
      );

      yield put(whiteboardPermissionGranted({ id, initiator }));
    }
  }
}
